var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNothingFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 309,
    viewBox: "0 0 613 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4012_20011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8861 285.833C-17.2139 256.143 12.8461 176.71 58.1791 128.133C113.305 69.0752 189.298 19.3962 336.198 36.2902C457.498 50.2472 532.804 111.447 558.42 142.967C599.153 193.067 628.581 263.758 604.049 292.994C562.881 342.068 392.79 258.57 300.529 256.868C208.268 255.166 73.6431 352.022 10.8861 285.833Z",
    fill: "#C2D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.776 238.4H126.595L59.2495 18.167C58.605 16.064 58.4632 13.839 58.8357 11.6712C59.2081 9.50333 60.0843 7.45322 61.3937 5.68586C62.7032 3.91851 64.4093 2.48328 66.3747 1.49571C68.3401 0.508149 70.51 -0.00416008 72.7095 2.54414e-05H363.476C366.486 -0.000236797 369.417 0.96616 371.836 2.7569C374.256 4.54764 376.037 7.06807 376.917 9.94703L446.776 238.4Z",
    fill: "#7A97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.342 212.182H164.638C161.6 212.181 158.643 211.206 156.201 209.4C153.759 207.593 151.961 205.051 151.071 202.147L100.073 35.3638C99.7482 34.3056 99.6764 33.186 99.8632 32.0951C100.05 31.0041 100.49 29.9722 101.149 29.0824C101.807 28.1926 102.665 27.4698 103.654 26.9721C104.642 26.4744 105.734 26.2157 106.841 26.2168H336.541C339.579 26.2173 342.536 27.1925 344.978 28.9988C347.42 30.8052 349.218 33.3474 350.108 36.2518L401.108 203.035C401.433 204.093 401.505 205.213 401.318 206.304C401.131 207.395 400.691 208.426 400.032 209.316C399.374 210.206 398.516 210.929 397.527 211.427C396.539 211.924 395.447 212.183 394.34 212.182H394.342Z",
    fill: "#1C3177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.596 238.399H556.669C558.105 238.4 559.528 238.683 560.855 239.233C562.183 239.783 563.389 240.589 564.405 241.605C565.42 242.622 566.226 243.828 566.776 245.155C567.325 246.483 567.608 247.906 567.608 249.342V263.96C567.607 266.861 566.455 269.644 564.403 271.695C562.352 273.746 559.57 274.899 556.669 274.899H137.535C134.634 274.899 131.852 273.746 129.8 271.695C127.749 269.644 126.596 266.861 126.596 263.96V238.399Z",
    fill: "#7A97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.012 127.228L205.17 98.0283",
    stroke: "#C2D1FF",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.344 127.228L171.953 98.0283",
    stroke: "#C2D1FF",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.18 127.228L334.338 98.0283",
    stroke: "#C2D1FF",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.515 127.228L301.115 98.0283",
    stroke: "#C2D1FF",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.525 145.69C243.525 145.69 264.03 134.381 284.857 145.69",
    stroke: "#C2D1FF",
    strokeWidth: 11.336,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.464 111.223C465.092 111.217 462.794 110.401 460.95 108.91C459.105 107.418 457.826 105.341 457.325 103.023C455.397 94.3301 454.174 87.6921 455.876 81.4831C457.918 74.1201 463.306 69.8091 469.109 65.6831C473.022 62.9091 475.738 58.6991 476.041 54.9671C476.13 53.7376 475.928 52.5045 475.451 51.3676C474.975 50.2307 474.238 49.222 473.299 48.4231C467.212 42.5161 457.356 51.7071 456.915 52.1041C456.915 52.1041 448.635 59.1141 442.484 51.7641C436.333 44.4141 442.484 37.1271 442.484 37.1271C446.452 33.4423 451.017 30.4582 455.984 28.3021C467.823 23.2541 479.103 25.1451 487.751 33.4971C490.88 36.4293 493.313 40.0253 494.871 44.021C496.428 48.0167 497.07 52.3105 496.751 56.5871C495.989 66.5341 490.151 76.2991 481.117 82.6871C476.876 85.6941 476.076 86.7591 475.88 87.1001C475.395 88.6381 476.995 95.8431 477.6 98.5601C477.935 100.079 477.925 101.654 477.572 103.169C477.219 104.684 476.532 106.101 475.559 107.315C474.587 108.53 473.356 109.511 471.955 110.187C470.554 110.863 469.019 111.217 467.464 111.223V111.223Z",
    fill: "#FEC272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.475 147.292C479.133 147.292 484.53 141.893 484.53 135.233C484.53 128.573 479.133 123.174 472.475 123.174C465.817 123.174 460.42 128.573 460.42 135.233C460.42 141.893 465.817 147.292 472.475 147.292Z",
    fill: "#FEC272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4012_20011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 612.998,
    height: 308.999,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingFound);
export default __webpack_public_path__ + "static/media/NothingFound.66872448cf19421382b013aa0bcd1b25.svg";
export { ForwardRef as ReactComponent };